import { Fragment } from 'react'
import BodyText from 'LuxKit/Typography/BodyText'
import Divider from 'LuxKit/Divider'
import ListItemLoadingSkeleton from 'LuxKit/List/ListItemLoadingSkeleton'
import TextLoadingBox from 'LuxKit/Typography/TextLoadingBox'
import Group from 'components/utils/Group'

const SKELETON_ROW_KEYS = ['first', 'second', 'third']

function ChatLandingChatsLoading() {
  return (
    <Group direction="vertical" gap={12} fullWidth>
      <BodyText variant="small" weight="bold">
        <TextLoadingBox width="12ch" />
      </BodyText>
      <div>
        {SKELETON_ROW_KEYS.map((key, index) => (
          <Fragment key={key}>
            {index > 0 && <Divider kind="primary" />}
            <ListItemLoadingSkeleton size="medium" subtitle />
          </Fragment>
        ))}
      </div>
    </Group>
  )
}

export default ChatLandingChatsLoading
